export const AddNewGuestToTableIcon = () => {
  return (
    <svg
      width="23"
      height="23"
      viewBox="0 0 23 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.123169"
        y="0.671875"
        width="21.9029"
        height="21.9029"
        rx="5.48629"
        fill="url(#paint0_linear_1871_5975)"
      />
      <rect
        x="0.123169"
        y="0.671875"
        width="21.9029"
        height="21.9029"
        rx="5.48629"
        fill="black"
        fillOpacity={0.1}
      />
      <path d="M10.2117 6.1582H11.9375V17.0885H10.2117V6.1582Z" fill="white" />
      <path
        d="M5.60925 10.7598H16.5396V12.4856H5.60925V10.7598Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1871_5975"
          x1="4.62326"
          y1="0.671875"
          x2="24.6211"
          y2="23.0764"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#026051" />
          <stop offset="1" stopColor="#3B5F59" stopOpacity={0} />
          <stop offset="1" stopColor="#47A092" />
        </linearGradient>
      </defs>
    </svg>
  );
};
